export const environment = {
  apiUrl: 'https://ot-backend.sca.kinexon.com',
  appUrl: 'http://cv.sports.kinexon.com',
  cognito: {
    clientId: '1br8090il57ps8mppok1o4n5jf',
    domain: 'sca-core-prod-user.auth.eu-central-1.amazoncognito.com',
    redirectSignIn: 'https://cv.sports.kinexon.com/login',
    redirectSignOut: 'https://cv.sports.kinexon.com/login',
    userPoolId: 'eu-central-1_Clrh3EgFO',
  },
  matomo: {
    siteId: 4,
    trackerUrl: 'https://sports-usage-analytics.kinexon.com/',
  },
  production: true,
  sentry: {
    dsn: 'https://1eb9a57feb8770ee4d7117e53d22433a@o4507407408496640.ingest.de.sentry.io/4507407743058000',
    enabled: true,
    environment: 'prod',
  },
};
